import { createContext, useContext } from "react";

export const StoresContext = createContext({
  Stores: [],
  fetchStores: () => { },
  fetchStore: () => { },
  updateStore: () => { },
  HideStoresSkeleton: true,
  setHideStoresSkeleton: () => { },
  isUpdatedStores: false,
  removeStores: () => { },
  StoresError: null,
  storeListPosition: 0,
  handleStoreListPosition: () => { },
  setStoreListPosition: () => { },
  fetchUnregisteredStores: () => { },
  usersType: "registered",
  setUsersType: () => {},
  removeReq: () => {},
});

export const useStoresContext = () => useContext(StoresContext);
